module.exports = __webpack_public_path__ + "static/media/31-4.d9261114.mp3";